import { stages, values } from 'bundles/apex/deals/config';

export const orderedStages = [
  stages.pitching,
  stages.sourcing,
  stages.evaluating,
  stages.transacting,
  stages.closed,
  stages.dead,
];

export const restrictedOrderedStages = [
  stages.closed,
];

export function getOrderedStages(restricted) {
  return restricted ? restrictedOrderedStages : orderedStages;
}

export function getOrderedColumns(viewConfig, selectedBroker) {
  return [
    values.incomplete,
    values.displayName,
    ...getConfiguredColumns(values, viewConfig, selectedBroker),
  ];
}

function getConfiguredColumns(values, viewConfig, selectedBroker) {
  const keys = viewConfig.columns?.length ? viewConfig.columns : defaultOptionalKeys;
  return keys
    .map(key => key === GROSS_AMOUNT_KEY
      ? getGrossCommissionIncomeValue(values, viewConfig, selectedBroker)
      : values[key])
    .filter(Boolean);
}

function getGrossCommissionIncomeValue(values, viewConfig, selectedBroker) {
  if (viewConfig?.brokerGross === 'weighted') {
    return selectedBroker ? values.weightedBrokerGrossCommissionIncome : values.weightedGrossCommissionIncome;
  } else {
    return selectedBroker ? values.brokerGrossCommissionIncome : values.grossCommissionIncome;
  }
}

// Virtual key: a single user-configurable column slot whose concrete column resolves at render time
// from `viewConfig.brokerGross` and the active broker filter (see `getGrossCommissionIncomeValue`).
export const GROSS_AMOUNT_KEY = 'grossAmount';

export const defaultOptionalKeys = [
  'identifier',
  'location',
  'dealTypeLabel',
  'propertyTypeLabel',
  'brokers',
  'transactionValue',
  GROSS_AMOUNT_KEY,
  'openTasks',
  'nextCriticalDate',
];

export const optionalKeys = [
  'address',
  'address2',
  'agreementTypeLabel',
  'brokers',
  'buildingSize',
  'buyerTenant',
  'capRate',
  'closeDate',
  'closeProbability',
  'contractExecutionDate',
  'createdAt',
  'deadReason',
  'dealTypeLabel',
  GROSS_AMOUNT_KEY,
  'grossCommissionAmount',
  'grossCommissionPercent',
  'identifier',
  'leaseExpirationDate',
  'leaseRate',
  'leaseStartDate',
  'leaseTermMonths',
  'leaseTypeLabel',
  'listingAssociation',
  'listingExecutionDate',
  'listingExpirationDate',
  'location',
  'lotSizeAcres',
  'netOperatingIncome',
  'nextCriticalDate',
  'numberOfUnits',
  'occupancyPercent',
  'openTasks',
  'outsideCommissionAmount',
  'propertyName',
  'propertySubtypeLabel',
  'propertyTypeLabel',
  'renewalOptionNoticeDate',
  'requirements',
  'sellerLandlord',
  'spaceSizeSf',
  'transactionValue',
  'uncollectedAmount',
  'yearBuilt',
  'zip',
];
